<template>
    <div class="all">
      <Head></Head>
      <div class="bannerShop">
        <img src="../assets/dingzhi01.jpg" alt="">
        <img src="../assets/dingzhi02.jpg" alt="">
        <img src="../assets/dingzhi03.jpg" alt="">
        <img src="../assets/dingzhi04.jpg" alt="">
        <img src="../assets/dingzhi05.jpg" alt="">
        <img src="../assets/dingzhi06.jpg" alt="">
        <img src="../assets/dingzhi07.jpg" alt="">
        <img src="../assets/dingzhi08.jpg" alt="">
        <img src="../assets/dingzhi09.jpg" alt="">
        <img src="../assets/dingzhi10.jpg" alt="">
        <img src="../assets/dingzhi11.jpg" alt="">
        <img src="../assets/dingzhi12.jpg" alt="">
        <img src="../assets/dingzhi13.jpg" alt="">
        <img src="../assets/dingzhi14.jpg" alt="">
        <img src="../assets/dingzhi15.jpg" alt="">
        <img src="../assets/dingzhi16.jpg" alt="">
        <img src="../assets/dingzhi17.jpg" alt="">
      </div>
      <div class="text" style="margin-top: 30px;">
        <p>1. 数量价格：限100本以上方可 按照要求加印公司LOGO和文字内容。</p>
        <p>2.制作内容：封面加印LOGO和文字：可以选择烫金、烫银、压印、压金属牌效果；</p>
        <p>&nbsp;&nbsp;&nbsp;内页加插页：可以选择单色印刷或者彩色印刷；</p>
        <p>&nbsp;&nbsp;&nbsp;内页加印LOGO或文字：也可以在现有款式上每页加印LOGO或者文字；</p>
        <p>&nbsp;&nbsp;&nbsp;内页重新印刷:根据客户要求，印刷客户设计的格式印刷内页；</p>
        <p>3.制作周期：交货期一般是20天左右，数量大的或者是需要加急的单子另行协商。</p>
        <p>4.笔记本定制签订合同后，收取客户30%订金才正式安排生产。</p>
        <p>5. 付款方式：合同签订时预收30%订金，完工后验收合格付清余款。 　</p>
      </div>
      <Pagetail></Pagetail>
    </div>
</template>

<script>
  import Pagetail from '../assembly/Pagetail'
  import Head from '../assembly/Head'
  import {getclass_tive1,gettice_index} from '../api/index'
  import img from '../assets/zanwu.png'
  import {getshopping} from "../api/List";
    export default {
        name: "bannerShop",
      components: {
        Pagetail, Head
      },
      data(){
          return{

          }
      },
      mounted() {

      },
      methods:{

      }
    }
</script>

<style scoped lang="less">
  .bannerShop{
    width: 700px;
    margin: 0 auto;
    margin-top: 30px;
    text-align: center;
    img{
      display: block;
    }
  }
  .text{
    width: 700px;
    margin: 0 auto;
    font-size: 14px;
    line-height: 20px;
    color: #a9a9a9;
  }
</style>



// WEBPACK FOOTER //
// src/components/bannerShop2.vue